import { VariableValueSimulator } from '../api/variable-value-simulator';

export class ArrayValueSimulator implements VariableValueSimulator {
  constructor(
    private options: {
      length: number;
      simulator: VariableValueSimulator;
    }
  ) {}

  generateNextValue(): number[] {
    return new Array(this.options.length)
      .fill(0)
      .map((v) => this.options.simulator.generateNextValue() as number);
  }
}
